import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import HeroSection from "@/sections/HeroSection";
import ProblemSection from "@/sections/ProblemSection";
import SolutionSection from "@/sections/SolutionSection";
import ProgramPathsSection from "@/sections/ProgramPathsSection";
import LevelsSection from "@/sections/LevelsSection";
import FeaturesSection from "@/sections/FeaturesSection";
import NoFatigueScoreSection from "@/sections/NoFatigueScoreSection";
import SubscriptionSection from "@/sections/SubscriptionSection";
import SupportSection from "@/sections/SupportSection";
import DisclaimerSection from "@/sections/DisclaimerSection";
import InsideTheAppSection from "@/sections/InsideTheAppSection";

export default function Landing() {
  useEffect(() => {
    document.title = "NFP — Train Smarter. Perform Better. | Nofatigue Programming";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "NFP — Nofatigue Programming. A premium fitness programming app for athletes — track and field, boxing, basketball — plus strength & conditioning, mobility, and general fitness."
      );
    }
  }, []);

  return (
    <div className="bg-[#0a0a0a] text-white" data-testid="page-landing">
      <Navigation />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <InsideTheAppSection />
        <ProgramPathsSection />
        <LevelsSection />
        <FeaturesSection />
        <NoFatigueScoreSection />
        <SubscriptionSection />
        <SupportSection />
        <DisclaimerSection />
      </main>
      <Footer />
    </div>
  );
}
